import { Typography, Form, Select, Row, Col, Input } from "antd";
import { ReactComponent as DropdownIcon } from "../assets/dropdown-icon.svg";
const { Text } = Typography;

interface ActionTypeProps {
  name: string;
  title: string;
  value?: string | null;
  moreText?: string | null;
  hint?: string | null;
  reverseHint?: string | null;
  onActionChange?: (values: {
    action: string;
    moreText?: string;
    hint?: string;
    reverseHint?: string;
  }) => void;
}

export const ActionType = ({ 
  name, 
  title,
  value,
  moreText,
  hint,
  reverseHint,
  onActionChange 
}: ActionTypeProps) => {
  const selectedValue = Form.useWatch(name);
  const moreTextValue = Form.useWatch(`${name}_moreText`);
  const hintValue = Form.useWatch(`${name}_hint`);
  const reverseHintValue = Form.useWatch(`${name}_reverse_hint`);

  // 當任何值改變時通知父組件
  const handleValueChange = (field: string, newValue: string) => {
    if (!onActionChange) return;

    const values = {
      action: field === 'action' ? newValue : selectedValue || '',
      moreText: field === 'moreText' ? newValue : moreTextValue,
      hint: field === 'hint' ? newValue : hintValue,
      reverseHint: field === 'reverseHint' ? newValue : reverseHintValue
    };

    onActionChange(values);
  };

  return (
    <Row gutter={[16, 24]}>
      <Col xs={24} sm={24}>
        <Text className="!text-[15px]">{title}</Text>
        <Form.Item
          name={name}
          className="mt-2"
          initialValue={value}
        >
          <Select
            placeholder="請選擇"
            className="!h-[40px]"
            allowClear
            onChange={(value) => handleValueChange('action', value)}
          >
            <Select.Option value="sit" text="坐下">坐下</Select.Option>
            <Select.Option value="stand" text="站起">站起</Select.Option>
            <Select.Option value="turn" text="轉身">轉身</Select.Option>
            <Select.Option value="bow" text="揖手">揖手</Select.Option>
            <Select.Option value="salute" text="敬禮">敬禮</Select.Option>
            <Select.Option value="other" text="其他">其他</Select.Option>
          </Select>
        </Form.Item>
        {selectedValue === "other" && (
          <Form.Item
            name={`${name}_moreText`}
            initialValue={moreText}
            rules={[{ required: true, message: "請輸入其他動作內容指示" }]}
            className="mt-2"
          >
            <Input.TextArea
              placeholder="請輸入其他動作內容指示"
              rows={1}
              className="!min-h-[60px]"
              onChange={(e) => handleValueChange('moreText', e.target.value)}
            />
          </Form.Item>
        )}
      </Col>
      {/* {selectedValue === "other" && (
        <>
          <Col xs={24} sm={8}>
            <Text className="!text-[15px]">輸入提示詞</Text>
            <Form.Item
              name={`${name}_hint`}
              initialValue={hint}
              className="mt-2"
            >
              <Input
                placeholder="請輸入提示詞"
                className="!h-[40px]"
                onChange={(e) => handleValueChange('hint', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Text className="!text-[15px]">輸入反向提示詞</Text>
            <Form.Item
              name={`${name}_reverse_hint`}
              initialValue={reverseHint}
              className="mt-2"
            >
              <Input
                placeholder="請輸入反向提示詞"
                className="!h-[40px]"
                onChange={(e) => handleValueChange('reverseHint', e.target.value)}
              />
            </Form.Item>
          </Col>
        </>
      )} */}
    </Row>
  );
};

